module.exports = __webpack_public_path__ + "img/photo_260720945_1.9a9e07a3.png";